import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { dailyForecastState } from '@store';

import { DailyForecastData } from '../store/types';

const getFilteredData = (data: DailyForecastData | undefined, days: number) => {
  if (!data?.daypart?.length) {
    return [];
  }
  const { moonPhase, moonPhaseCode, sunriseTimeUtc, sunsetTimeUtc } = data;

  return Array.from({ length: days }, (_, index) => ({
    moonPhase: moonPhase[index],
    moonPhaseCode: moonPhaseCode[index],
    sunriseTimeUtc: sunriseTimeUtc[index],
    sunsetTimeUtc: sunsetTimeUtc[index],
  }));
};

export const useSunriseSunset = (days: number = 1) => {
  const { data } = useRecoilValue(dailyForecastState);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => getFilteredData(data, days), [data]);
};
